export default "__VITE_ASSET__QVLMA9Rt__"